import { render, staticRenderFns } from "./AppointAdd.vue?vue&type=template&id=a96d4808&scoped=true&"
import script from "./AppointAdd.vue?vue&type=script&lang=js&"
export * from "./AppointAdd.vue?vue&type=script&lang=js&"
import style0 from "./AppointAdd.vue?vue&type=style&index=0&id=a96d4808&lang=less&scoped=true&"
import style1 from "./AppointAdd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96d4808",
  null
  
)

export default component.exports